export interface CustomScoring{
    id : string
    name : string
    fieldName : string
    accountId : number
    applied : boolean
    deleted : boolean
    scope : CustomScoringScope
    scoring : scoring
    datasetID?: string
    fieldId?: string
    _id?: string
    isNew?: boolean
}

export enum CustomScoringScope {
    INTERNAL="INTERNAL", 
    EXTERNAL = "EXTERNAL", 
    GLOBAL = "GLOBAL",
    FORMULA = "FORMULA"
}

export interface scoring{
    textValues : string[]
    minNumberValue : number | null
    maxNumberValue : number | null
    label : string
    order : number
}